module.exports = __webpack_public_path__ + "img/withdraw.a21a0ed1.svg";